import type { EliteOnboardingStatusResponse } from '../../../types/misc.types'
import {
  getEliteFocusEligiblePlan,
  getElitePlanStatusLabel,
  getEliteSubscriptionPlanPriceDisplayExGst
} from './eliteOnboardingFocusPlan'
import { convertEpochToDate, roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'

export function EliteMembershipCurrentPlanCard({
  eliteOnboardingStatus
}: {
  eliteOnboardingStatus?: EliteOnboardingStatusResponse
}) {

  const upgradePlan = eliteOnboardingStatus?.subscriptionDetails?.upgradeDetails?.upgradePlanDetails
  if (!upgradePlan) {
    return null
  }
  const currentPlan = eliteOnboardingStatus?.subscriptionDetails?.subscriptionPlanDetails
  const currentPlanTenurePeriod = currentPlan?.effectivePlanTenure?.period ?? currentPlan?.basePlanTenure?.period
  const currentPlanTenureValue = Number(
    currentPlan?.effectivePlanTenure?.value ?? currentPlan?.basePlanTenure?.value ?? 0
  )
  const currentPlanTenureLabel = getPlanTenureLabel({
    period: currentPlanTenurePeriod,
    value: currentPlanTenureValue
  })
  const planStatusLabel = getElitePlanStatusLabel(eliteOnboardingStatus)
  const currentPlanSuffix = currentPlanTenureLabel === 'Yearly' ? '/yr' : '/mo'
  const activePlan = getEliteFocusEligiblePlan(eliteOnboardingStatus)
  const priceDisplay = getEliteSubscriptionPlanPriceDisplayExGst(
    eliteOnboardingStatus?.subscriptionDetails,
    activePlan
  )
  const currentAmount = priceDisplay.primaryExGst
  const listStrikeAmount = priceDisplay.listStrikeExGst
  const showStrikeThrough = priceDisplay.showStrikeThrough
  const subscriptionExpiresOn = eliteOnboardingStatus?.subscriptionDetails?.subscriptionExpiresOn
  return (
    <div className='relative z-10 rounded-2xl bg-[#FFFFFF] overflow-hidden'>
      <div className=' border-b border-[#E6E6E6]'>
        <div className='flex items-start justify-between gap-3 px-5 py-4'>
          <div>
            <p className='text-[#65321D] text-[14px] font-[500] leading-[1.2]'>
              Elite {currentPlanTenureLabel}
            </p>
            <p className='mt-1 text-[13px] font-[500] leading-[1.2] text-[#BB4F22]'>{planStatusLabel}</p>
          </div>
          <div className='text-right'>
            <p className='text-[14px] font-[500] text-[#232323]'>
              {roundOffAndFormatNumberWithCurrency(currentAmount)}
              {currentPlanSuffix}
              <span className='text-[12px] font-[400] text-[#8E9393]'>+GST</span>
            </p>
            {showStrikeThrough ? (
              <p className='text-[13px] text-[#8E9393] line-through'>
                {roundOffAndFormatNumberWithCurrency(listStrikeAmount)}
                {currentPlanSuffix}
              </p>
            ) : null}
          </div>
        </div>
        <hr />
        <div className='text-13 px-5 py-4 text-left'>Valid till {subscriptionExpiresOn ? convertEpochToDate(subscriptionExpiresOn, '%d %b %Y') : 'N/A'}</div>
      </div>
    </div>
  )
}

function getPlanTenureLabel({ period, value }: { period?: string; value: number }) {
  if (period === 'YEAR' || value >= 12) {
    return 'Yearly'
  }
  return 'Monthly'
}
